import SvgIcon from '@mui/material/SvgIcon'
import React from 'react'

import { IconProps } from './types'

const ReproductionProtocolIcon: React.FC<IconProps> = (props = {}) => {
  const { color, fontSize, style, ...rest } = props

  return (
    <SvgIcon viewBox="0 0 24 24" style={{ color, fontSize, ...style }} {...rest}>
      <path d="M21.48,5.64a2.07,2.07,0,0,0-.62-1.48,2,2,0,0,0-1.49-.62H18.32V1.44H16.21v2.1H7.79V1.44H5.68v2.1h-1A2.12,2.12,0,0,0,2.52,5.65h0V20.39A2.12,2.12,0,0,0,4.63,22.5H19.37a2.12,2.12,0,0,0,2.11-2.11V5.65h0Zm-16.85,0H19.37v2.1H4.63ZM19.37,20.39H4.63V11h0V9.86H19.37V11h0Z" />
      <path d="M16.62,11.45l0,0v0A1.53,1.53,0,0,0,15.14,11a3.46,3.46,0,0,0-1.72.84,2.65,2.65,0,0,0-1.06,2.82,1.54,1.54,0,0,1-.44.16,1.41,1.41,0,0,0-1,.63,3.07,3.07,0,0,0-.36,1.74,2.34,2.34,0,0,1,0,.58c-.15.34-.27.36-.63.42h0a1.76,1.76,0,0,0-1.24.63.53.53,0,0,0,.07.72.56.56,0,0,0,.32.11.5.5,0,0,0,.39-.18.86.86,0,0,1,.61-.28h0a1.57,1.57,0,0,0,1.4-1,2.67,2.67,0,0,0,.12-1,2.32,2.32,0,0,1,.21-1.2c0-.07.11-.1.38-.17a2.28,2.28,0,0,0,.9-.45,1.86,1.86,0,0,0,1,.07,3.54,3.54,0,0,0,1.65-.83,3.63,3.63,0,0,0,1.06-1.52A1.64,1.64,0,0,0,16.62,11.45Zm-.69,1.34a2.73,2.73,0,0,1-.77,1,2.59,2.59,0,0,1-1.19.62c-.18,0-.49.05-.63-.12s.05-1.11.78-1.75a2.34,2.34,0,0,1,1.42-.64.55.55,0,0,1,.4.13c.16.2,0,.57,0,.65l0,.07Zm-5.85,6.34Z" />
      <path d="M9.73,10.89a1.69,1.69,0,1,0,1.65,1.69A1.68,1.68,0,0,0,9.73,10.89Zm0,2.54a.85.85,0,1,1,.83-.85A.84.84,0,0,1,9.73,13.43Z" />
    </SvgIcon>
  )
}

export default ReproductionProtocolIcon
